<!-- 原因说明弹窗 -->
<template>
    <custom-modal
        width="400px"
        title="原因说明"
        :visible="visible"
        @on-close="handleClose"
    >
        <a-spin :spinning="loading">
            <a-form-model ref="form" v-bind="formLayout" :model="form" :rules="formRules">
                <a-form-model-item label="原因说明" prop="reason">
                    <a-textarea
                        v-model="form.reason"
                        :max-length="200"
                        :rows="6"
                        style="width: 90%"
                    />
                </a-form-model-item>
            </a-form-model>
        </a-spin>
        <template slot="customFooter">
            <a-button type="primary" :loading="loading" @click="handleOk">
                确定
            </a-button>
        </template>
    </custom-modal>
</template>

<script>
import {
    Button as AButton,
    FormModel as AFormModel,
    Spin as ASpin,
    Input as AInput
} from 'ant-design-vue'
import CustomModal from '@components/CustomModal'
import { updateReasonSalaryBankFlowReconciliation } from '@/service/project/attendanceAndSalaryServices'

export default {
    name: 'ReasonModal',
    components: {
        AButton,
        AFormModel,
        AFormModelItem: AFormModel.Item,
        CustomModal,
        ASpin,
        ATextarea: AInput.TextArea
    },
    data() {
        return {
            loading: false,
            visible: false,
            form: {
                reason: undefined
            },
            formLayout: {
                labelCol: {
                    span: 24
                },
                wrapperCol: {
                    span: 24
                }
            },
            formRules: {
                reason: {
                    required: true,
                    message: '此项为必填'
                }
            }
        }
    },
    methods: {
        handleClose() {
            this.visible = false
        },
        async handleOk() {
            this.loading = true
            try {
                await updateReasonSalaryBankFlowReconciliation({
                    id: this.form.id,
                    reason: this.form.reason
                })
                this.$emit('on-refresh')
                this.handleClose()
            } catch (error) {
                this.$message.error(error.message)
            } finally {
                this.loading = false
            }
        },
        open(record) {
            this.visible = true
            this.form = {
                ...record
            }
            this.getInfo()
        }
    }
}
</script>
